var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f6d6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.05c0-.304.246-.55.55-.55.304 0 .55.246.55.55v3.3c0 .911-.739 1.65-1.65 1.65H1.65C.739 11 0 10.261 0 9.35V3.3c0-.911.739-1.65 1.65-1.65h3.3c.304 0 .55.246.55.55 0 .304-.246.55-.55.55h-3.3c-.304 0-.55.246-.55.55v6.05c0 .304.246.55.55.55H7.7c.304 0 .55-.246.55-.55v-3.3zM9.9 1.1H7.15c-.304 0-.55-.246-.55-.55 0-.304.246-.55.55-.55h3.3c.304 0 .55.246.55.55v3.3c0 .304-.246.55-.55.55-.304 0-.55-.246-.55-.55V1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.789 6.989c-.215.215-.563.215-.778 0-.215-.215-.215-.563 0-.778l6.05-6.05c.215-.215.563-.215.778 0 .215.215.215.563 0 .778l-6.05 6.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.e42f436d1bd5f95e4c47a591f13accbe.svg";
export { ForwardRef as ReactComponent };